<template>
  <li :class="classes" v-on="$listeners">
    <span class="list-item__content"><slot /></span>
  </li>
</template>

<script>
import classes from '~~/common/vue/mixins/classes';
import scrollIntoParentView from '~~/common/vue/mixins/scroll-into-parent-view';

export default {
  name: 'EListItem',
  mixins: [classes, scrollIntoParentView],
  props: {
    /**
     * Toggles the smooth active style transition
     */
    transition: {
      type: Boolean,
      cssClass: true,
      default: true,
    },
    highlighted: {
      type: Boolean,
      cssClass: true,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin li-highlight {
  background-color: var(--color-highlight-primary);
}

.list-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: $font-m;
  list-style-type: none;
  padding: 0 $space-s;
  height: $tappable-area-size-mobile;

  @include desktop {
    height: $space-3l;
  }

  &:hover,
  &:active {
    @include li-highlight;
  }

  &:focus,
  &:focus-within {
    @extend %keyboard-nav-focus;
  }

  // doubling up to have higher specificity because of the .keyboard-mode body class
  &.list-item:focus-within {
    outline-offset: -$space-2s;
  }
}

.list-item--highlighted {
  @include li-highlight;
}

.list-item--transition {
  transition: background-color $timing-2s $easing;
}

.list-item__content {
  flex-grow: 1;
}
</style>

<docs>
```js
<EList>
  <EListItem>First item</EListItem>
  <EListItem>Second item</EListItem>
  <EListItem>Third item</EListItem>
</EList>
```
</docs>
